module.exports = __webpack_public_path__ + "media/images/plan-b3e2b524c3328f67cdd0fd016ce46f1d.png";